<template>
    <div itemscope itemtype="http://schema.org/CreativeWork">

        <social-media-meta :object='object'></social-media-meta>

        <div class='row'>
            <div class='col-md-2 hidden-print'></div>
            <div class='col-md-10'>
                <h1 :itemprop="meta(object._index, 'title')">{{object.searchable.title[0]}}</h1>
            </div>
        </div>

        <div v-for='property in object.order'>
            <div v-if='object[property.column]'>
                <!-- All non custom properties -->
                <noncustom-prop :object='object'
                    v-if='ignored.indexOf(property.column) == -1'
                    :metatag="meta(object._index, property.column)"
                    :property='property'>
                </noncustom-prop>

                <!-- Creator -->
                <!-- Added Entry -->
                <span v-if='property.column == "author" ||
                    property.column == "custom_added_entry"'>
                    <noncustom-prop :object='object'
                        :property='property'
                        :metatag="meta(object._index, property.column)"
                        link='searchable-actors-keyword'>
                    </noncustom-prop>
                </span>

                <!-- Genre/Form -->
                <span v-if='property.column == "custom_genre_form"'>
                    <noncustom-prop :object='object'
                        :property='property'
                        :metatag="meta(object._index, property.column)"
                        link='searchable-genre-keyword'>
                    </noncustom-prop>
                </span>

                <!-- Other Terms -->
                <span v-if='property.column == "custom_other_terms"'>
                    <noncustom-prop :object='object'
                        :property='property'
                        :metatag="meta(object._index, property.column)"
                        link='searchable-terms-keyword'>
                    </noncustom-prop>
                </span>

                <!-- Accession Date -->
                <div class='row' v-if='property.column == "custom_accession_date"'>
                    <div class='col-md-2 hidden-print'></div>
                    <div class='col-md-3'><strong>{{property.label}}</strong></div>
                    <div class='col-md-7' :itemprop="meta(object._index, property.column)">{{formatDate(object, 'custom_accession_date')}}</div>
                </div>

                <!-- Archive Number -->
                <div class='row' v-if='property.column == "custom_archive_number"'>
                    <div class='col-md-2 hidden-print'></div>
                    <div class='col-md-3'><strong>{{property.label}}</strong></div>
                    <div class='col-md-7' :itemprop="meta(object._index, property.column)">{{processArchiveNumber(object, 'custom_archive_number')}}</div>
                </div>

                <!-- Record Date -->
                <div class='row' v-if='property.column == "custom_record_date"'>
                    <div class='col-md-2 hidden-print'></div>
                    <div class='col-md-3'><strong>{{property.label}}</strong></div>
                    <div class='col-md-7' :itemprop="meta(object._index, property.column)">{{formatDate(object, 'custom_record_date')}}</div>
                </div>

            </div>

            <!-- Custom Subject -->
            <div class='row' v-if='property.column == "custom_subject" && hasSubjects'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <div v-if='object.sub_pers'>
                        <div v-for='entry in object.sub_pers.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-actors-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.sub_corp'>
                        <div v-for='entry in object.sub_corp.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-actors-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.sub_topic'>
                        <div v-for='entry in object.sub_topic.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-topics-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.sub_geo'>
                        <div v-for='entry in object.sub_geo.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-places-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.sub_occu'>
                        <div v-for='entry in object.sub_occu.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-occupations-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.sub_func'>
                        <div v-for='entry in object.sub_func.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-functions-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                    <div v-if='object.categ_13'>
                        <div v-for='entry in object.categ_13.value[0][0].value'>
                            <a :href="generateLinkNew({'searchable-events-keyword': entry})"
                                :itemprop="meta(object._index, property.column)" v-html='entry'>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Heirarchy -->
            <div class='row' v-if='property.column == "custom_hierarchy"'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <heirarchy :object='object' :property='property'></heirarchy>
                </div>
            </div>

            <!-- Related -->
            <div class='row' v-if='property.column == "custom_related" && hasNonAssociationRelations(object.relation_count)'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <related :object='object'></related>
                </div>
            </div>

            <!-- Associations -->
            <div class='row' v-if='property.column == "custom_associations" &&
                object.relation_count.parent &&
                object.relation_count.parent.association'>
                <div class='col-md-2 hidden-print'></div>
                <div class='col-md-3'><strong>{{property.label}}</strong></div>
                <div class='col-md-7'>
                    <a :href="generateLinkNew({'indices': 'association', 'child-keyword': object._id})">
                        {{object.relation_count.parent.association}} Associations
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import manageProperties from './../../mixins/manageProperties.js'
    import manageRelations from './../../mixins/manageRelations.js'
    import manageMetatags from './../../mixins/manageMetatags.js'
    import ViewRelated from './../../mixins/viewRelated.js'
    import SocialMediaMetaVue from './parts/socialMediaMeta.vue'
    import NoncustomVue from './parts/noncustom.vue'
    import HeirarchyVue from './parts/heirarchy.vue'

    export default {
        mixins: [manageProperties, manageRelations, manageMetatags, ViewRelated],
        props: ['object'],
        components: {
            'noncustom-prop': NoncustomVue,
            'heirarchy': HeirarchyVue,
            'social-media-meta': SocialMediaMetaVue
        },
        data: function () {
            return {
                ignored: [
                    'series_nam',
                    'custom_added_entry',
                    'custom_archive_number',
                    'author',
                    'custom_accession_date',
                    'custom_record_date',
                    'custom_genre_form',
                    'custom_related',
                    'custom_other_terms',
                ],
            }
        },
        computed: {
            hasSubjects: function () {
                return this.object.sub_geo || this.object.sub_pers ||
                    this.object.sub_corp || this.object.sub_topic ||
                    this.object.sub_occu || this.object.sub_func ||
                    this.object.categ_13
            }
        }
    }
</script>
